import { render, staticRenderFns } from "./HolidaysBookingDetails.vue?vue&type=template&id=98dd6d4e&scoped=true&"
import script from "./HolidaysBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./HolidaysBookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dd6d4e",
  null
  
)

export default component.exports